import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Notification } from 'components/CustomNotification';
import { useNavigate } from 'react-router-dom';
import {
  getCountryList,
  getJobTypeList,
  getWorkTypeList,
} from 'redux/features/DropDownSlice';
import { CountryCode } from 'redux/features/LoginSlice';
import { getJobPostList, JobDelete } from 'redux/features/PostJobSlice';
import { ProfileJobList, JobPopoverContent } from '../jobs/JobPosts.style';
import DynModel from 'components/Modal';
import { Divider, Tooltip } from '@mui/material';
import moment from 'moment';
import {
  BasicIconButton,
  BrandIconSpinner,
  Button,
  CustomPopover,
  Virtuoso,
} from 'components';
import { EndStyle } from 'pages/home/Home.style';
import { Capacitor } from '@capacitor/core';

import { ReactComponent as SampleCompany } from 'assert/images/Jobs/sampleCompany.svg';
import { ReactComponent as More } from 'assert/images/Home/moreHorizantal.svg';
import { ReactComponent as Delete } from 'assert/images/More/delete.svg';
import { ReactComponent as Edit } from 'assert/images/More/postEdit.svg';
import { ReactComponent as Visibility } from 'assert/images/Common/visibility.svg';
import { ReactComponent as ViewList } from 'assert/images/Jobs/viewList.svg';
import { ReactComponent as Info } from 'assert/images/More/info.svg';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

const pageSize = 15;

export default function UserJobs() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const Countrycode = useSelector((state) => state?.LoginReducer?.countryCode);
  const { getProfile } = useSelector((state) => state?.ProfileSlice);
  const userId = getProfile.userId;

  const { jobList, workTypeList, countryList } = useSelector(
    (state) => state?.DropdownReducer
  );

  const [page, setPage] = useState(0);
  const [deleteDetails, setDeleteDetails] = useState(null);
  const [userJobList, setUserJobList] = useState([]);
  const [isHasMore, setIsHasMore] = useState(false);
  const [loading, setLoading] = useState(true);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [openPopover, setOpenPopover] = useState(false);

  useEffect(() => {
    jobList?.length === 0 && dispatch(getJobTypeList());
    workTypeList?.length === 0 && dispatch(getWorkTypeList());
    countryList?.length === 0 && dispatch(getCountryList());
    !Countrycode?.country_code && dispatch(CountryCode());
  }, []);

  const handleFetchData = () => {
    setLoading(true);
    const payload = {
      url: `${`jobPost/userId/${userId}?page=${page}&size=${pageSize}&clientOffSet=${new Date().getTimezoneOffset()}`}`,
    };
    dispatch(getJobPostList(payload))
      .then((res) => {
        setLoading(false);
        setPage(page + 1);
        setUserJobList([...userJobList, ...res?.rows]);
        setIsHasMore(res?.count);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (Countrycode?.country_code) {
      handleFetchData();
    }
  }, [Countrycode]);

  const JobDeleteFun = () => {
    setDeleteLoading(true);
    dispatch(JobDelete(deleteDetails))
      .then((res) => {
        if (res?.message) {
          Notification('success', 'Deleted Successfully');
          const newArr = userJobList.filter(
            (item) => item.jobPostId !== deleteDetails.id
          );
          setUserJobList(newArr);
          setDeleteLoading(false);
          setDeleteDetails(null);
        }
      })
      .catch(() => {
        setDeleteDetails(null);
        setDeleteLoading(false);
      });
  };

  const showDetails = (id) => {
    navigate(`/jobs-detail/${id}`);
  };

  const content = (id, data) => {
    const is24Passed = moment().diff(moment(data?.created_At), 'hours') >= 24;
    return (
      <JobPopoverContent className="job-popover-content">
        <div onClick={() => showDetails(id)}>
          <Visibility />
          {t('profile.DetailView')}
        </div>
        <div
          className={clsx(is24Passed && 'job-edit-disable')}
          onClick={() => (is24Passed ? {} : navigate(`/postjob?postid=${id}`))}
        >
          <Edit />
          {t('profile.Edit')}
          <div
            className="edit-info-container"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
          >
            <Tooltip
              arrow
              title={<span>{t('profile.EditPostRule')}</span>}
              classes={{ popper: 'edit-tooltip' }}
              placement="bottom-end"
            >
              <Info />
            </Tooltip>
          </div>
        </div>
        {data?.preTemplate && (
          <div
            onClick={async () => {
              setOpenPopover(false);
              if (Capacitor.isNativePlatform()) {
                navigate(`/jobs/applied-list?id=${data?.jobPostId}`);
              } else {
                window.open(
                  `/jobs/applied-list?id=${data?.jobPostId}`,
                  '_blank'
                );
              }
            }}
          >
            <ViewList className="user-job-view" />
            {t('profile.AppliedList')}
          </div>
        )}
        <div
          className="deletelist-icon"
          onClick={() => {
            setDeleteDetails({
              id,
              attachment: data?.companyLogo ? [data?.companyLogo] : [],
            });
            setOpenPopover(false);
          }}
        >
          <Delete />
          {t('profile.Delete')}
        </div>
      </JobPopoverContent>
    );
  };

  const userJobListLength = userJobList?.length;

  return (
    <ProfileJobList>
      <BrandIconSpinner
        loading={deleteLoading || (loading && userJobListLength === 0)}
      />
      {userJobListLength > 0 && (
        <Virtuoso
          minHeight={'73vh'}
          data={userJobList}
          useWindowScroll
          components={{
            Footer: () => {
              return (
                !isHasMore && (
                  <EndStyle>
                    <span>* * *</span>
                  </EndStyle>
                )
              );
            },
          }}
          endReached={isHasMore ? handleFetchData : () => {}}
          itemContent={(index, list) => {
            return (
              <div
                key={index}
                style={{
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                <div className="job-list-item">
                  {list?.companyLogo ? (
                    <img
                      alt="job-company-logo"
                      className="job-list-company-logo"
                      src={list?.companyLogo}
                    />
                  ) : (
                    <SampleCompany className="job-list-sample-company-logo" />
                  )}
                  <div className="job-list-short-preview">
                    <div className="job-title">{list?.jobTitle}</div>
                    <div className="job-companyname">{list?.companyName}</div>
                    <div className="job-list-types">
                      {list?.jobTypeIds?.map((itemId, index) => {
                        return (
                          <span key={index}>
                            {
                              jobList.find(
                                (jobItem) => jobItem.value === itemId
                              )?.label
                            }
                            {list?.jobTypeIds?.length !== index + 1 && ',  '}
                          </span>
                        );
                      })}
                    </div>
                    <div className="job-list-types">
                      {list?.workTypeIds?.map((itemId, index) => {
                        return (
                          <span key={index}>
                            {
                              workTypeList.find(
                                (workTypeItem) => workTypeItem.value === itemId
                              )?.label
                            }
                            {list?.workTypeIds?.length !== index + 1 && ',  '}
                          </span>
                        );
                      })}
                    </div>
                    <div className="job-list-post-time">
                      {moment(list?.updated_At).fromNow(true)}
                    </div>
                  </div>
                  <div className="more-outline">
                    <CustomPopover
                      handlePopoverClick={() => setOpenPopover(true)}
                      isOpen={openPopover}
                      action={<BasicIconButton icon={<More />} size="small" />}
                      content={content(list.jobPostId, list)}
                    />
                  </div>
                </div>
                <Divider />
              </div>
            );
          }}
        />
      )}
      {!(userJobListLength > 0) && !loading && (
        <div className="profile-create-post">
          <Button
            onClick={() => navigate('/postjob')}
            label={t('profile.PostYourJob')}
            variant="text"
          />
        </div>
      )}
      <DynModel
        removeHeader
        modalchanges="jobConfirm"
        handleCancelModal={() => setDeleteDetails(null)}
        openModal={deleteDetails !== null}
        content={
          <div className="confirmModal">
            <div className="title">{t('profile.DelConfirmation')}</div>
            <div>
              <Button
                label={t('profile.Cancel')}
                variant="text"
                onClick={() => setDeleteDetails(null)}
              />
              <Button
                label={t('profile.Yes')}
                color="error"
                onClick={JobDeleteFun}
              />
            </div>
          </div>
        }
      />
    </ProfileJobList>
  );
}
